export default function accountConfirmationModal() {
    return {
        orderId: null,
        action: null,
        message: null,
        title: null,

        setData(data) {
            this.orderId = data.orderId;
            this.action = data.action;
            this.message = data.message;
            this.title = data.title;
        },

        async confirm() {
            if (!this.orderId || this.orderId === '' || this.orderId === null) {
                this.$dispatch('toast', { message: window.translations.customer.alerts.no_order_to_skip, type: 'error' })
                return;
            }
            switch (this.action) {
                case 'skipOrder':
                    await this.skipOrder(this.orderId);
                    this.$dispatch('toast', { message: window.translations.customer.global.order_skipped, type: 'success'})
                    this.closeModal('account-confirmation-modal');
                    break;
                case 'sendNow':
                    await this.sendOrderNow(this.orderId);
                    this.$dispatch('toast', { message: window.translations.customer.global.order_sent, type: 'success' })
                    this.closeModal('account-confirmation-modal');
                    break;
                default:
                    this.closeModal('account-confirmation-modal');
                    this.$dispatch('toast', { message: 'No action available', type: 'error' })
                    break;
            }
        },
    }
}